/** Откладываем выполнение функции на wait миллисекунд */
export function debounce<F extends (...args: any[]) => any>(
  func: F,
  wait: number,
  immediate = false
): F {
  let timeout;

  return function executedFunction(...args) {
    const later = function () {
      timeout = null;

      if (!immediate) {
        func.apply(this, args);
      }
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(this, args);
    }
  } as F;
}
